/****************************************************
 * Module Name:  brokerProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class BrokerProxy {
  static GetAllBrokerDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/broker/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllBrokerDetailByEmployeeId = (employeeid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/${employeeid}/detail/broker/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleBrokerById = (brokerid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/broker/${brokerid}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleEmployeesBrokerById = (brokerid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/${brokerid}/detail/broker/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateBroker = (brokerid, brokerData, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/user/detail/broker/${brokerid}/detail`,
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(brokerData),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static getCustomersBrokerMini = (customerid, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/brokercustomer/customer/${customerid}/mini`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
